import React from "react";
import LogoIconVisem from '../../src/assets/icons/logo.svg';
import LogoIconCrediton from '../../src/assets/icons/logo-crediton.svg';
import {paymentType, paymentTypeVisem, sections, sectionsVisem} from "./data-constants";

export const config = () => {
    const config = {};
    const logo = process.env.REACT_APP_ONE_CONFIG;
    const buildVersion = process.env.REACT_APP_BUILD_NUMBER

    switch (logo) {
        case 'VISEM':
            config.logo = <LogoIconVisem />;
            config.copyright = '© 2021, ONE.app';
            config.iconTitle = `${process.env.PUBLIC_URL}/favicon.ico`;
            config.appTitle = 'ONE.app';
            config.className = 'login-logoVisem';
            config.section = sectionsVisem
            config.validatePurities = true
            config.validateThings = false
            config.buildVersion = buildVersion
            config.paymentType = paymentTypeVisem
            break;
        case 'CREDITON':
            config.logo = <LogoIconCrediton />;
            config.copyright = '© 2021, ONLINE КРЕДИТОН';
            config.iconTitle = `${process.env.PUBLIC_URL}/faviconCred.ico`;
            config.appTitle = 'ONLINE КРЕДИТОН';
            config.className = 'login-logoCrediton';
            config.section = sections
            config.validatePurities = false
            config.validateThings = true
            config.buildVersion = buildVersion
            config.paymentType = paymentType
            break;
        default:
            config.logo = <LogoIconVisem />;
            config.copyright = '© 2021, ONE.app';
            config.iconTitle = `${process.env.PUBLIC_URL}/favicon.ico`;
            config.appTitle = 'ONE.app';
            config.className = 'login-logoVisem';
            config.section = sectionsVisem
            config.validatePurities = true
            config.validateThings = false
            config.buildVersion = buildVersion
            config.paymentType = paymentTypeVisem
            break;
    }
    return config;
};